module.exports = __webpack_public_path__ + "img/logo_cetak.e69f7032.png";